import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  displayName: Yup.string().required('Display name is required'),
  password: Yup.string()
    .required('Password is required')
    .min(10, 'Password length must be more than 10 characters')
    .matches(
      /^.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?].*$/,
      'Need one special character',
    )
    .matches(/^.*[A-Z].*$/, 'Need one capital letter'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Password confirm is required'),
});
